module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.showCart !== null ? (_vm.showCart ? 'animated bounceInRight' : 'animated bounceOutRight') : '',
    attrs: {
      "id": "cartPopup"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.closeCartPopup
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("Your Cart")]), _vm._v(" "), _c('div', {
    staticClass: "cart"
  }, [_c('div', {
    staticClass: "products"
  }, _vm._l((_vm.cart), function(row, index) {
    return (_vm.showFullList ? true : (index < 4)) ? _c('div', {
      staticClass: "product"
    }, [_c('div', {
      staticClass: "image"
    }, [(row.image && row.image !== '') ? _c('img', {
      attrs: {
        "src": row.image,
        "alt": row.title
      }
    }) : _c('img', {
      attrs: {
        "src": require("../assets/img/food.png"),
        "alt": row.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('div', {
      staticClass: "quantity"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_vm._v("x " + _vm._s(row.quantity))]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_vm._v("£" + _vm._s((row.discount > 0 ? row.discount : row.price).toFixed(2)))])])]), _vm._v(" "), _c('div', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.deleteProductFromCart(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(!_vm.showFullList && _vm.cart.length > 4) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.showFullList = true
      }
    }
  }, [_vm._v("View " + _vm._s(_vm.cart.length - 4) + " product" + _vm._s(_vm.cart.length > 5 ? 's' : '') + " more")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "totals"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('strong', [_vm._v("£" + _vm._s(_vm.getCartTotal.toFixed(2)))])])]), _vm._v(" "), _c('div', {
    staticClass: "btns text-center"
  }, [_c('div', {
    on: {
      "click": _vm.goToCheckout
    }
  }, [_c('b-button', {
    staticClass: "btn-default btn-fill full-width"
  }, [_vm._v("Checkout")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ornaments"
  }, [_c('img', {
    staticClass: "lamps-right",
    attrs: {
      "src": require("../assets/img/lamps-right.png"),
      "align": "Lamps ornaments"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('strong', [_vm._v("Subtotal")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bb9635d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart-popup.vue
// module id = 545
// module chunks = 1